import type { EnumType } from "@pdfking/structs"

import type { ErrorName } from "#public"

// Formal engine error: an EnumType record (like forms' ValidationError), so
// Failure/SafePromise preserve the identity at `error.enum` and consumers can
// intercept a specific ErrorName from a Result.
export type EngineError<N extends ErrorName = ErrorName> = EnumType<N>

export const EngineError = <N extends ErrorName>(code: N): EngineError<N> => ({ enum: code })
